import axios from 'axios';
import toCamelCase from '../utils/camelCase';
import getExpConfig from '../utils/getExpConfig';
import { recordApiResponse, REMOVE_LINE_ITEM_S3 } from '../utils/newRelic';

export const removePpeLineItemFromS3 = (params) => {
  const url = `${getExpConfig('eleanor-base-url')}/api/deletelineitem`;

  const promise = axios.post(url, params);
  return recordApiResponse(promise, REMOVE_LINE_ITEM_S3, url, params)
    .then((response) => toCamelCase(response.data))
    .catch((error) => error);
};
